import React from "react";
import 'bootstrap/dist/css/bootstrap.min.css';
import '../components/custom.css';
import { Navbar, Nav, Container } from "react-bootstrap";


export const Navigation = (props) => {
  return (
    <Navbar bg="light" expand="lg" fixed="top" id="menu">
      <Container>
        <Navbar.Brand href="#page-top" className="nav-horizontal nav-band"> 
          <img 
          src="/img/logo.png" alt="Synchrony Technologies Logo"
          style={{width: "40px", height: "30px", paddingBottom: "0px"}} />
          
          </Navbar.Brand>
          
        <Navbar.Toggle aria-controls="navbar-nav" />
        <Navbar.Collapse id="navbar-nav">
        <span  className="insync-name"> Synchrony Technologies </span>
          <Nav className="ms-auto">
            <Nav.Link href="#features" className="page-scroll">
              Features
            </Nav.Link>
            <Nav.Link href="#about" className="page-scroll">
              About
            </Nav.Link>
            <Nav.Link href="#services" className="page-scroll">
              Services
            </Nav.Link>
            <Nav.Link href="#suites" className="page-scroll">
              Suites
            </Nav.Link>
            <Nav.Link href="#contact" className="page-scroll">
              Contact
            </Nav.Link>
          </Nav>
        </Navbar.Collapse>
      </Container>
    </Navbar>
  );
};
